import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import moment from 'moment'
import toast from 'react-hot-toast';
import { AddRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded, EditRounded } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { actionDeleteUser, actionFetchUsers } from '../../../actions/users';
import { StateUserParams } from '../../../types/users/usersParams';
import {Button, Loader} from '../../';
import { UsersListHeader } from '../../../utils/constants';
import { users } from '../../../assets';

import './userTable.css'
import { actionFetchProfiles } from '../../../actions/profile';

interface DeletePostParams {
  detailId: string;
  firstName: string;
}

const UserTable = () => {
  const dispatch                  = useDispatch<AppDispatch>();
  const {isLoading, getAllUsers}  = useSelector((state: RootState) => state?.userList);
  const { getAllProfiles }        = useSelector((state: RootState) => state?.profileList)
  const [allPosts, setAllPosts]   = useState<StateUserParams[]>(getAllUsers);
  const [isOpen, setIsOpen]       = useState<{ [key: number]: boolean }>({})
  const [page, setPage]           = useState<number>(1);

  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }

  const handleDeletePost = ({detailId, firstName}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete this user ${firstName}?`)) {
      // Dispatch the deletePost action here
      dispatch(actionDeleteUser({detailId}))
        .then(() => {
          setAllPosts(allPosts.filter(post => post._id !== detailId));
          // Show success toast after successfully deleting the post
          toast.success('User deleted successfully');
        })
        .catch((error) => {
          // Handle any errors that occur during the deletion process
          toast.error('Error deleting post: ' + error.message);
        });
    }
  };
  
  useEffect(() => {
    dispatch(actionFetchUsers({page})); // You can pass the page number as needed
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(actionFetchProfiles({page}))
  }, [page, dispatch])
  
  //isLoading, data, currentPage and numberOfPages
  if(!allPosts.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
        <div className='empty-profile-card-header'>
          <span><DoNotDisturbAltRounded /></span>
          <h1> No Post Found </h1>
        </div>
        <Link className='view-patients' to="/users/create-user">create user</Link>
      </div>
    </>
  )

  return (
    <>
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Users</h3>
          <Button buttonWrapper="button-wrapper" linkButton linkTo="users/view-users" linkClass="link-wrapper" linkName="View all" />
        </div>
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {UsersListHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPosts.map((detail, index) => {
                const profile  = getAllProfiles?.find((profile: any) => profile.userId === detail._id);
                const profileImage = profile?.selectedFile || users;
                const phone = profile?.phoneNumber;
                const dob = profile?.dateOfBirth;
                const sex = profile?.sex;
                
              return(
                <tr key={index}>
                  <td data-cell="image">
                  <div className="table-image">
                    {isLoading ? <Loader /> : (
                      <img src={profileImage} alt="img" />
                    )}
                  </div>
                </td>
                  <td data-cell="first name">{detail.firstName}</td>
                  <td data-cell="last name">{detail.lastName}</td>
                  <td data-cell="username">{detail.username}</td>
                  <td data-cell="created">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <Link to={`/users/edit-profile/${detail._id}`} className='button-menu-detail'>
                          <EditRounded />
                          <span>Edit profile</span>
                        </Link>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ detailId: detail._id, firstName: detail.firstName }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}
      </div>
    </>
  )
}

export default UserTable